import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Row,
  Col,
  Image,
  Layout,
  Card,
  Button,
  notification,
} from "antd";
import "./login.css"; // Optional: Custom styles
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/Login/actions";
import config from "../Services/apiEndPoints";

import BackgroundImage from "../Utils/styledBackgroundImage";

const { Title } = Typography;
const { Header } = Layout;

export default function Bothlogin() {
  const { successMessage, errorMessage, actionType } = useSelector(
    (state) => state.logIn
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const typeOfUser = location.pathname.split("logIn/")[1] || "existingUser";

  useEffect(() => {
    if (actionType === actions.LOGIN_SUCCESS && successMessage) {
      notification.success({
        message: successMessage,
      });
      navigate("/otpScreen");
      dispatch(actions.resetActionType());
    } else if (actionType === actions.LOGIN_ERROR && errorMessage) {
      // notification.error({
      //   message: errorMessage,
      // });
      // if (errorMessage === "User not found.") {
      //   // console.log(errorMessage)
      //   navigate("/newuser");
      // }
      dispatch(actions.resetActionType());
    }
  }, [actionType, successMessage, errorMessage]);

  const handleSubmit = async () => {
    try {
      const mobileNum = localStorage.getItem("mobileNumber");
      const payload = {
        mobileNumber: "+91" + mobileNum,
      };
      localStorage.setItem("mobileNumber", mobileNum);
      dispatch(actions.login(config.logIn, payload));
    } catch (e) {
      console.log("error", e);
    }
  };
  // () => navigate("/logIn/annadhanam")
  return (
    <div>
      <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
        <Row align="middle" gutter={16}>
          <Col
            xs={24}
            sm={6}
            md={6}
            lg={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <a
              href="https://sriramanavami.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image preview={false} src="/favicon.ico" />
              </div>
            </a>
          </Col>
        </Row>
      </Header>
      <BackgroundImage />
      <Row justify="center" style={{ height: "60vh", padding: "0 16px" }}>
        <Col xs={24} sm={18} md={12} lg={8} className="login-container">
          <Card className="w-full max-w-md mx-auto p-6 shadow-lg rounded-2xl border border-gray-200">
            <div
              className="flex items-center justify-between mb-4"
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              {/* <p className="text-lg font-semibold">Donations</p> */}
              <Button
                type="primary"
                onClick={() => {
                  handleSubmit();
                  localStorage.setItem("typeOfUser", "annadhanam");
                  sessionStorage.setItem("typeOfUser", "annadhanam");
                }}
              >
                Annadanam
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  handleSubmit();
                  localStorage.setItem("typeOfUser", "festival");
                  sessionStorage.setItem("typeOfUser", "festival");
                }}
                style={{ marginTop: "10px" }}
              >
                Festival
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
